<template>
    <p v-if="!dataLoaded">Loading...</p>
    <div v-else>
        <h3>{{user.fname}} {{user.lname}} </h3>
        <a :href="'mailto:'+user.email">{{user.email}}</a>
        <p>Account Type: {{ (user.admin) ? 'Administrator' : 'Salesperson' }}</p>
    </div>
</template>


<script>
import { CallApi } from '../Utilities'
    export default {
        name: 'UserDetails',
        data: function() {
            return {
                dataLoaded: false,
                user:{},
                ShowEdit:false
            }
        },
        methods: {
            fetchData: async function() {
                const apiResponse = await CallApi('GET', `/users/${this.$route.params.id}`)
                this.user = apiResponse.user
                this.dataLoaded = true
            }
        },
        mounted: function() {
            this.fetchData()
        }
    }
</script>
